import { render } from "./InfoLegal.vue?vue&type=template&id=534b0131"
import script from "./InfoLegal.vue?vue&type=script&lang=js"
export * from "./InfoLegal.vue?vue&type=script&lang=js"

import "./InfoLegal.vue?vue&type=style&index=0&id=534b0131&lang=scss"

import exportComponent from "/home/rubb/NiwCaetano/Frontend/governance/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__